import moment from 'moment';

export const workingTimeFormat = 'HH:mm';

export const defaultWorkingTime = {
  startTime: moment('08:00', workingTimeFormat),
  endTime: moment('17:00', workingTimeFormat),
};

const defaultDayWorking = {
  shifts: [],
};

export const defaultOpenDay = {
  mon: defaultDayWorking,
  tue: defaultDayWorking,
  wed: defaultDayWorking,
  thu: defaultDayWorking,
  fri: defaultDayWorking,
  sat: defaultDayWorking,
  sun: defaultDayWorking,
};

export const SETTING_AVAILABILITY = {
  AVAILABLE: '1',
  UNAVAILABLE: '0',
};
